'use client';

interface Props {
  /** When true, renders a styled inline button instead of a plain list-item link */
  inline?: boolean;
}

export default function CookieSettingsButton({ inline }: Props) {
  const handleClick = () => window.dispatchEvent(new CustomEvent('openCookieSettings'));

  if (inline) {
    return (
      <button
        onClick={handleClick}
        className="inline-flex items-center gap-2 font-semibold text-white px-5 py-2.5 rounded-xl transition-all hover:opacity-90"
        style={{ background: 'linear-gradient(135deg,#F97316,#EA580C)' }}
      >
        Open Cookie Settings
      </button>
    );
  }

  return (
    <li>
      <button
        onClick={handleClick}
        className="text-[13px] text-[#64748B] hover:text-white transition-colors duration-200 text-left"
      >
        Cookie Settings
      </button>
    </li>
  );
}
